<div class="carousel-parent" *ngIf=" !isHandset else mobileTemplate" >

  <button *ngIf="imageCarouselArray && imageCarouselArray.length > 0" (click)="handleCarouselPagination('back')" (mousedown)="startHoldScroll('back')" (mouseup)="stopHoldScroll()" title="Previous image in this set" type="button" class="btn carousel-btn ms-1 me-1">&lsaquo;</button>
  <div class="thumbnailsHolderSection boundSetMode" *ngIf="imageCarouselArray && imageCarouselArray.length > 0 && !isRSVMode" #carousel>
    <app-thumbnail [class.outlined]="t.name === displayName" class="thumb" *ngFor="let t of imageCarouselArray" [animate]="false" [showStacked]="false" [batchEditMode]="false" (recordSelectedEmitter)="handleSelectImageCarouselThumbnail(t)" [imageData]="t" [expandMode]="libViewModes.condensedMode"></app-thumbnail>
  </div>

  <div class="thumbnailsHolderSection" *ngIf="imageCarouselArray && imageCarouselArray.length > 0 && isRSVMode" #carousel>
    <app-thumbnail [class.outlined]="t.name === displayName" class="thumb" *ngFor="let t of imageCarouselArray" [animate]="true" [showStacked]="isRSVMode" (recordSelectedEmitter)="handleSelectImageCarouselThumbnail($event)" [isRelatedImageSetViewMode]='isRSVMode' [relatedImageSetViewData]="t"></app-thumbnail>
  </div>

  <div class="noThumbnailsHolderSection" *ngIf="!imageCarouselArray || imageCarouselArray.length === 0">
    <h3 style="line-height: 135px;">{{ noImageMSG }}</h3>
  </div>
  <button *ngIf="imageCarouselArray && imageCarouselArray.length > 0" (click)="handleCarouselPagination('forward')" (mousedown)="startHoldScroll('forward')" (mouseup)="stopHoldScroll()" title="Next image in this set" type="button" class="btn carousel-btn ms-1">&rsaquo;</button>
</div>


<ng-template #mobileTemplate>
  <div class="carousel-parent mobile">

    <div class="infoTextMobile" *ngIf="mainDataContainer?.length > 0">
      <h6 style="font-size: large; font-weight: 800;">{{currentSelectedImageIndex + 1}} of {{mainDataContainer.length}}</h6>
    </div>

    <div class="buttonContainerMobile">
      <app-slant-button *ngIf="(showButtonsInsteadOfCarousel && (mainDataContainer && mainDataContainer.length > 0))" (click)="goToPrevImage()" 
        [disabled]="currentSelectedImageIndex < 1"
        [btnIconClass]="'fas fa-chevron-double-left'"
        [btnColor]="'red'"
        [tooltip]="'Previous image in this set'">Prev Image</app-slant-button>
    
      <app-slant-button *ngIf="(showButtonsInsteadOfCarousel&& (mainDataContainer && mainDataContainer.length > 0))" (click)="goToNextImage()" 
        [disabled]="currentSelectedImageIndex >= mainDataContainer.length-1"
        [btnIconClass]="'fas fa-chevron-double-right'"
        [btnColor]="'blue'"
        [tooltip]="'Next image in this set'">Next Image</app-slant-button>
      </div>
  </div>
</ng-template>